import Details from '@/components/Details/Details';
import InfoLabel from '@/components/InfoLabel';
import Tip from '@/components/Tip/Tip';
import useFeature from '@/hooks/useFeature';
import IEventType from '@/types/IEventType';
import { Checkbox, Flex, Select, Text } from '@chakra-ui/react';
import { FcSms } from 'react-icons/fc';
import useSectionNotifications from './useSectionNotifications';

interface ISectionNotificationsProps {
	service: IEventType;
	onChange: (values: Partial<IEventType>) => void;
}

export default function SectionNotifications(props: ISectionNotificationsProps) {
	const isEnabled = useFeature('REMINDERS');
	const { t, handleSmsReminderChange, handleSmsConfirmationChange, handleSmsReminderHourChange, isLoading } =
		useSectionNotifications(props);

	if (!isEnabled) {
		return null;
	}

	return (
		<Details image={<FcSms />} title={t('Notifications')}>
			<Tip>{t('SMS will be sent to questions of type PHONE. Charges per SMS will be applied')}</Tip>
			<InfoLabel
				text={t('Confirmations')}
				help={t('Use this options to configure notifications when the booking is confirmed.')}
			/>

			<Flex mt="4">
				<Text size="sm">{t('Send an email when the reservation is confirmed')}</Text>
				<Checkbox disabled marginLeft="auto" isChecked={true} />
			</Flex>

			<Flex mt="2" mb="8">
				<Text size="sm">{t('Send a SMS when the reservation is confirmed')}</Text>
				<Checkbox
					isDisabled={isLoading}
					id="sms-confirmation-checkbox"
					name="sms-confirmation"
					marginLeft="auto"
					isChecked={props.service.notifications?.confirmation?.sms.enabled}
					onChange={handleSmsConfirmationChange}
				/>
			</Flex>

			<InfoLabel text={t('Reminders')} help={t('Use this options to send reminders before the event.')} />

			<Flex mt="2" mb="8">
				<Flex justifyContent="flex-start" alignItems="center">
					<Text size="sm">{t('Send sms')}</Text>
					<Select
						isDisabled={isLoading}
						flex="1"
						variant="flushed"
						ml="2"
						fontSize="md"
						marginTop="1px"
						value={props.service.notifications?.reminders?.at(0)?.timeBefore}
						onChange={handleSmsReminderHourChange}
					>
						<option value="PT1H">
							{t('one hour')} {t('before the event')}
						</option>
						<option value="PT2H">
							{t('two hours')} {t('before the event')}
						</option>
						<option value="PT24H">
							{t('one day')} {t('before the event')}
						</option>
						<option value="PT48H">
							{t('two days')} {t('before the event')}
						</option>
					</Select>
				</Flex>
				<Checkbox
					isDisabled={isLoading}
					id="sms-reminder-checkbox"
					name="sms-reminder"
					marginLeft="auto"
					isChecked={props.service.notifications?.reminders?.at(0)?.sms.enabled}
					onChange={handleSmsReminderChange}
				/>
			</Flex>
		</Details>
	);
}
